import React from 'react';
import { Image } from '../../../../../../components';

interface SlideImageProps {
  imageUrl?: string;
  altText: string;
}

export const SlideImage: React.FC<SlideImageProps> = ({
  imageUrl,
  altText,
}) => {
  return (
    <Image
      src={imageUrl}
      alt={altText}
      wrapperClassName="flex items-center justify-center bg-gray-100"
      imageClassName="w-full h-auto object-contain"
      imageStyle={{ maxHeight: '500px' }}
      objectFit="contain"
      fallbackComponent={
        <div className="flex items-center justify-center h-96 text-gray-400 bg-gray-100">
          No image available for this slide
        </div>
      }
    />
  );
};
